module.exports = __webpack_public_path__ + "829fc49e40437a9d52569a72aea10ebd.svg";


//////////////////
// WEBPACK FOOTER
// ./Content/icons/sets/admin-icons.svg
// module id = ./Content/icons/sets/admin-icons.svg
// module chunks = 8